import PropTypes from "prop-types";
import CMEMemberTimeLog from "./cme-member-time-log/cme-member-time-log";
import CMEProjectTimeLog from "./cme-project-time-log/cme-project-time-log";
import CMEGroupHeadProjectTimeLog from "./cme-group-head-project-time-log/cme-group-head-project-time-log";
import CMEGroupHeadDeal from "./cme-group-head-deal-log/cme-group-head-deal-log";
import "../dashboard-cme/dashboard-cme.scss";
import {
  compareCurrentSubdepartment,
  newDashboardMap,
} from "../new-dashboard-mapper";
import { DashboardGridSkeleton } from "../dashboard-skeletons/dashboard-skeletons";

const DashboardCME = (props) => {
  return (
    <div>
      {compareCurrentSubdepartment(
        [
          ...newDashboardMap.CME.user,
          ...newDashboardMap.CME.staffer,
          ...newDashboardMap.TechCME.staffer,
          ...newDashboardMap.All.user,
        ],
        props.currSubDepartment
      ) ? (
        <>
          {props?.isCMEMemberLoading ? (
            <DashboardGridSkeleton />
          ) : (
            props.memberItems && (
              <CMEMemberTimeLog
                items={props.memberItems}
                fetchData={props.fetchData}
              />
            )
          )}
          {props?.isCMEProjectLoading ? (
            compareCurrentSubdepartment(
              [
                ...newDashboardMap.CME.staffer,
                ...newDashboardMap.TechCME.staffer,
                ...newDashboardMap.All.user,
              ],
              props.currSubDepartment
            ) ? (
              <DashboardGridSkeleton />
            ) : null
          ) : (
            props.projectItems && (
              <CMEProjectTimeLog items={props.projectItems} />
            )
          )}
        </>
      ) : null}
      {compareCurrentSubdepartment(
        [...newDashboardMap.CME.grouphead, ...newDashboardMap.All.user],
        props.currSubDepartment
      ) ? (
        <>
          {props?.isCMEGroupHeadProjectLoading ? (
            <DashboardGridSkeleton />
          ) : (
            props.groupHeadProjectItems && (
              <CMEGroupHeadProjectTimeLog items={props.groupHeadProjectItems} />
            )
          )}
          {props?.isCMEGroupHeadDealLoading ? (
            <DashboardGridSkeleton />
          ) : (
            props.groupHeadDealitems && (
              <CMEGroupHeadDeal items={props.groupHeadDealitems} />
            )
          )}
        </>
      ) : null}
    </div>
  );
};

DashboardCME.propTypes = {
  memberItems: PropTypes.array,
  projectItems: PropTypes.array,
  groupHeadProjectItems: PropTypes.array,
  groupHeadDealitems: PropTypes.array,
  fetchData: PropTypes.func,
  currSubDepartment: PropTypes.string,
  isCMEMemberLoading: PropTypes.bool,
  isCMEProjectLoading: PropTypes.bool,
  isCMEGroupHeadProjectLoading: PropTypes.bool,
  isCMEGroupHeadDealLoading: PropTypes.bool,
};

export default DashboardCME;